// views
import BindingPosView from '@/components/views/Menu/binding-pos.vue'
import BrandScheduleTableView from '@/components/views/Schedule/BrandScheduleTable.vue'
import CrBindingView from '@/components/views/Menu/CrBinding.vue'
import CreateMenuView from '@/components/views/Menu/CrMenu.vue'
import CreateOptionView from '@/components/views/Menu/CrMenuOption.vue'
import CrScheduleView from '@/components/views/Schedule/CrSchedule.vue'
import MenuBuildView from '@/components/views/Menu/menu-build.vue'
import MenuInfoView from '@/components/views/Menu/MenuInfo.vue'
import MenuSettingRuleStoreCopyView from '@/components/views/Menu/MenuSettingRuleStoreCopy.vue'
import MenuSettingRuleStoreCopyLogsView from '@/components/views/Menu/MenuSettingRuleStoreCopyLogs.vue'
import MenuSettingRuleStoreUpdateView from '@/components/views/Menu/MenuSettingRuleStoreUpdate.vue'
import MenuSettingRuleStoreUpdateLogsView from '@/components/views/Menu/MenuSettingRuleStoreUpdateLogs.vue'
import MenuStepView from '@/components/views/Menu/menu-step.vue'
import ProductImageView from '@/components/views/Menu/ProductImage.vue'
import ProductSettingView from '@/components/views/Menu/ProductSetting.vue'
import StoreMenuView from '@/components/views/Menu/store-menu.vue'
import UpdatedBlockView from '@/components/views/Menu/UpMenuBlock.vue'
import UpdatedCategoryView from '@/components/views/Menu/UpMenuCategory.vue'
import UpdatedJoinMenuView from '@/components/views/Menu/UpJoinMenu.vue'
import UpdatedMenuView from '@/components/views/Menu/UpMenu.vue'
import UpdatedPackageView from '@/components/views/Menu/UpMenuPackage.vue'
import UpdatedProductView from '@/components/views/Menu/UpMenuProduct.vue'
import UpMenuAdjustView from '@/components/views/Menu/up-menu-adjust.vue'
import UpMenuOptionView from '@/components/views/Menu/up-menu-option.vue'
import UpScheduleView from '@/components/views/Schedule/UpSchedule.vue'

const brandToStoreMenu = [
  {
    path: 'brand/:brand_id/store/menu',
    component: StoreMenuView,
    name: 'StoreMenu',
    meta: {
      title: '門市菜單管理 / 菜單管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/ajust/menu',
    component: StoreMenuView,
    name: 'StoreToMenu',
    meta: {
      title: '選擇門市-配料庫',
      description: '',
      route: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/build/menu',
    component: StoreMenuView,
    name: 'StoreToMenu',
    meta: {
      title: '選擇門市-菜單建置',
      description: '',
      route: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/schedule/menu',
    component: StoreMenuView,
    name: 'StoreToMenu',
    meta: {
      title: '選擇門市-菜單排程',
      description: '',
      route: '',
      docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/:menu_id/info',
    component: MenuInfoView,
    name: 'StoreMenuInfo',
    meta: {
      title: '門市菜單管理 / 菜單資訊',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/schedule',
    component: BrandScheduleTableView,
    name: 'StoreMenuSchedule',
    meta: {
      title: '門市菜單管理 / 排程管理',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/:menu_id/schedule/create',
    component: CrScheduleView,
    name: 'StoreMenuScheduleCreate',
    meta: {
      title: '門市菜單管理 / 新增排程',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/schedule/edit/g/:group_id',
    component: UpScheduleView,
    name: 'StoreMenuScheduleEditG',
    meta: {
      title: '門市菜單管理 / 編輯排程',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/schedule/edit/s/:schedule_id',
    component: UpScheduleView,
    name: 'StoreMenuScheduleEditS',
    meta: {
      title: '門市菜單管理 / 編輯排程',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/:menu_id/edit',
    component: UpdatedMenuView,
    name: 'StoreMenuEdite',
    meta: {
      title: '門市菜單管理 / 編輯菜單',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/:menu_id/edit/up-join',
    component: UpdatedJoinMenuView,
    name: 'StoreMenuEditeUpJoin',
    meta: {
      title: '門市菜單管理 / 編輯菜單',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/step',
    component: MenuStepView,
    name: 'StoreMenuStep',
    meta: {
      title: '門市菜單管理 / 配料庫',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/binding-pos',
    component: BindingPosView,
    name: 'StoreMenuBindingPos',
    meta: {
      title: '門市菜單管理 / 菜單綁定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/build',
    component: MenuBuildView,
    name: 'StoreMenuBuild',
    meta: {
      title: '門市菜單管理 / 菜單建置',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/build/create',
    component: CreateMenuView,
    name: 'StoreMenuBuildCreate',
    meta: {
      title: '門市菜單管理 / 新增菜單',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/build/option/create/',
    component: CreateOptionView,
    name: 'StoreMenuOptionCreateView',
    meta: {
      title: '門市菜單管理 / 新增菜單',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/option',
    component: UpMenuOptionView,
    name: 'StoreMenuOption',
    meta: {
      title: '門市菜單管理 / 配料',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/option/create',
    component: CrBindingView,
    name: 'StoreMenuOptionCreate',
    meta: {
      title: '門市菜單管理 / 新增配料',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/adjust',
    component: UpMenuAdjustView,
    name: 'StoreMenuAdjust',
    meta: {
      title: '門市菜單管理 / 配料群組',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/adjust/create',
    component: CrBindingView,
    name: 'StoreMenuAdjustCreate',
    meta: {
      title: '門市菜單管理 / 新增配料群組',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/category',
    component: UpdatedCategoryView,
    name: 'StoreMenuCategory',
    meta: {
      title: '門市菜單管理 / 商品分類',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/category/create',
    component: CrBindingView,
    name: 'StoreMenuCategoryCreate',
    meta: {
      title: '門市菜單管理 / 新增商品分類',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/product',
    component: UpdatedProductView,
    name: 'StoreMenuProduct',
    meta: {
      title: '門市菜單管理 / 商品',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/product/create',
    component: CrBindingView,
    name: 'StoreMenuProductCreate',
    meta: {
      title: '門市菜單管理 / 新增商品',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/block',
    component: UpdatedBlockView,
    name: 'StoreMenuBlock',
    meta: {
      title: '門市菜單管理 / 品項選擇區',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/block/create',
    component: CrBindingView,
    name: 'StoreMenuBlockCreate',
    meta: {
      title: '門市菜單管理 / 新增品項選擇區',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/package',
    component: UpdatedPackageView,
    name: 'StoreMenuPackage',
    meta: {
      title: '門市菜單管理 / 套餐',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/package/create',
    component: CrBindingView,
    name: 'StoreMenuPackageCreate',
    meta: {
      title: '門市菜單管理 / 新增套餐',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/image',
    component: ProductImageView,
    name: 'StoreMenuImage',
    meta: {
      title: '門市菜單管理 / 圖片庫',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/store/:store_id/menu/setting',
    component: ProductSettingView,
    name: 'StoreMenuSetting',
    meta: {
      title: '門市菜單管理 / 別名/描述/警語',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: true
    }
  },
  {
    path: 'brand/:brand_id/menu/setting-rule/store-copy',
    component: MenuSettingRuleStoreCopyView,
    name: 'MenuSettingRuleStoreCopyView',
    meta: {
      title: '門市菜單管理 / 菜單同步權限設定',
      description: '',
      route: '菜單管理/菜單同步權限設定',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/menu/setting-rule/store-copy/logs',
    component: MenuSettingRuleStoreCopyLogsView,
    name: 'MenuSettingRuleStoreCopyLogsView',
    meta: {
      title: '門市菜單管理 / 菜單同步權限設定歷史紀錄',
      description: '',
      route: '菜單管理/菜單同步權限設定/歷史紀錄',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/menu/setting-rule/store-update',
    component: MenuSettingRuleStoreUpdateView,
    name: 'MenuSettingRuleStoreUpdateView',
    meta: {
      title: '門市菜單管理 / 菜單編輯權限設定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  },
  {
    path: 'brand/:brand_id/menu/setting-rule/store-update/logs',
    component: MenuSettingRuleStoreUpdateLogsView,
    name: 'MenuSettingRuleStoreUpdateLogsView',
    meta: {
      title: '門市菜單管理 / 菜單編輯權限設定',
      description: '',
      route: '',
      requiresAuth: true,
      isShowInJkos: false
    }
  }
]

export default brandToStoreMenu



// WEBPACK FOOTER //
// ./src/routes/modules/brand-to-store-menu.js